import React, {useContext, useEffect, useState} from "react";
import AuthContext from "../../Services/AuthContext";
import StyledModal from "../../Component/StyledModal";

function AddAgreementDocument(props) {
    const title = 'Wyraź zgodę';
    const description = 'By wyrazić zgodę, należy przesłać plik potwierdzający (pierwsza strona PIT za zeszły rok) Dozwolony format: [pdf, jpg, jpeg lub png]';

    const [user] = useContext(AuthContext);
    const [file, setFile] = useState(null);

    function _send() {
        const data = new FormData();
        data.append('file', file);

        fetch(`/api/children/${props.add?.children}/agreement/${props.add?.sid}/file`, {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(() => {
                props.onSuccess();
                props.dismiss();
            })
            .catch(err => {
                console.log(err)
            })
    }

    return (
        <StyledModal isOpen={props.add} title={title} description={description} send={_send} dismiss={props.dismiss}>
            <input type="file" name="file" onChange={(e) => setFile(e.target.files[0])}/>
        </StyledModal>
    );
}

export default AddAgreementDocument;